module.exports = __webpack_public_path__ + "img/6350e84.png";